export class tncCMSModel {
    tersmandconditions: any;
}


export class tncEntryIdObj {
  	entryIds = [
      { id:'1tklfmGLe0iZiLIUyoInrz', text : 'tersmandconditions'}
  	];
}